import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Constants from "../../../../common/Constants";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import MasterList from "../../../common/MasterList";
import { fetchMasterList } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { formatDate } from "../../../../common/Validations";

const requiresMaterialTraceNumber = (jobcard) =>
  jobcard?.jobcardStatus === Constants.TRANSACTION_STATUS.OPEN &&
  jobcard?.toDeptCode === "DEPT001" &&
  !String(jobcard?.fromDeptCode || "").trim();

const GenerateJobCardList = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      fetchMasterList(Constants.TRANSACTION.GENERATEJOBCARD.open_jobcard)
    ); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userData = useSelector((state) => state?.user);
  const deptCodeList = userData?.data?.departments?.map((entry) => entry.deptCode);


  //userData?.data?.category === Constants.MASTER.USERS.ADMIN 

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store

  let completeRowsData =
    masterList[Constants.TRANSACTION.GENERATEJOBCARD.open_jobcard.name]?.data;

  let rowsData = completeRowsData
  if (userData?.data?.category === Constants.MASTER.USERS.TEAMLEAD) {
    rowsData = completeRowsData?.filter(
      (user) => deptCodeList?.includes(user?.toDeptCode)
    );
  }


  const handleClick = (e, jobcard) => {
    e.preventDefault();
    props.handleInputValue(jobcard)
  };


  const columnsData = [
    {
      name: t("msg_reports.msg_jobstatus_report.actions"),
      cell: (row) => (
        <Button
          className="btnTable"
          disabled={
            requiresMaterialTraceNumber(row) &&
            !String(row.materialTraceNumber || "").trim()
          }
          title={
            requiresMaterialTraceNumber(row) && !row.materialTraceNumber
              ? "Enter the Wire Trace Number before acknowledgement"
              : "Acknowledge job card"
          }
          onClick={(e) => handleClick(e, row.jobcard)}
        >
          {"Acknowledge"}
        </Button>
      ),
      center: true,
      width: "200px",
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
    },
    {
      name: "Wire Trace Number",
      selector: (row) => row.materialTraceNumber,
      sortable: true,
      width: "210px",
      cell: (row) =>
        row.materialTraceNumber ||
        (requiresMaterialTraceNumber(row) ? "Required" : "-"),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_quantity"),
      selector: (row) => row.batchTotalQtyDozen,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-text-status">
            {row.originalQuantityPerJobCard} / {row.quantityPerJobCard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_fromDepartment"),
      selector: (row) => row.fromDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.fromDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.fromDeptCode} - {row.fromDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toDepartment"),
      selector: (row) => row.toDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptCode} - {row.toDeptName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.sizeCode}</p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.requiredDate"),
      selector: (row) => row.requiredDate,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDate(row.requiredDate)}</p>
        </div>
      ),
    },

  ];


  return (
    <div>
      {rowsData?.length > 0 && (
        <div>
          <MasterList
            columnsData={columnsData}
            cardHeader={false}
            customCardHeader={true}
            handleAckAllJobCards={props.handleAckAllJobCards}
            rowsData={rowsData}
            paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
            pagination
            handleClose
            selectableRows={true}
            handleRowSelected={props.onSelectedRowsChange}
            clearSelectedRows={props.clearSelectedRows}
          />
        </div>
      )}
    </div>
  );
};

export default GenerateJobCardList;
